import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

export interface CobrandStore {
  cobrandData: {
    activeTabValue: string;
    selectedCards: { cardname: string; checked: boolean }[];
    allCarouselCards?: string[];
  };
  setCobrandData: (data: {
    activeTabValue: string;
    selectedCards: { cardname: string; checked: boolean }[];
    allCarouselCards?: string[];
  }) => void;
}

const initialState: CobrandStore = {
  cobrandData: {
    activeTabValue: 'personal',
    selectedCards: [],
    allCarouselCards: [],
  },
  setCobrandData: () => null,
};

const CobrandStore: StateCreator<CobrandStore> = set => {
  return {
    ...initialState,
    setCobrandData: data => {
      set({
        cobrandData: { ...data },
      });
    },
  };
};

export const useStore = createAppStore(CobrandStore, {
  usePersistentStore: false,
});
